import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CoingeckoDexNamesEnum } from '@shared/enums/dex-names.enum';
import { CoingeckoCexes } from '@shared/constants/coingecko-info';
import {
    CoinGeckoCoinInterface,
    CoinInfoTickersInterface,
    GetCoinHistoricalDataParams,
    GetCoinHistoricalDataResponse,
} from '@shared/models/coingecko.model';

@Injectable()
export class CoingeckoApiService {
    private readonly apiUrl = 'https://api.coingecko.com/api/v3';
    private readonly API_KEY = 'CG-ahcE9iMtYvQdnXtUAzLhzeSf';

    constructor(private readonly http: HttpClient) {}

    getCoinInfoByContract(
        platformId: string,
        address: string,
    ): Observable<CoinGeckoCoinInterface | null> {
        return this.http.get<CoinGeckoCoinInterface>(
            this.apiUrl + `/coins/${platformId}/contract/${address}`,
            {
                headers: {
                    'x-cg-demo-api-key': this.API_KEY,
                },
            },
        );
    }

    getCoinTickers(
        coinId: string,
        exchangeIds?: (CoingeckoDexNamesEnum | CoingeckoCexes)[],
    ): Observable<CoinInfoTickersInterface> {
        return this.http.get<CoinInfoTickersInterface>(this.apiUrl + `/coins/${coinId}/tickers`, {
            params: {
                exchange_ids: exchangeIds.toString(),
                depth: true,
                market_data: true,
                developer_data: true,
            },
            headers: {
                'x-cg-demo-api-key': this.API_KEY,
            },
        });
    }

    searchToken(coinSymbol: string): Observable<any> {
        return this.http.get(this.apiUrl + `/search`, {
            params: {
                query: coinSymbol,
            },
            headers: {
                'x-cg-demo-api-key': this.API_KEY,
            },
        });
    }

    getCoinHistoricalChartData(coinId: string, params: GetCoinHistoricalDataParams) {
        return this.http.get<GetCoinHistoricalDataResponse>(
            this.apiUrl + `/coins/${coinId}/market_chart`,
            {
                params: { ...params },
                headers: {
                    'x-cg-demo-api-key': this.API_KEY,
                },
            },
        );
    }
}
